(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelectorAll("details")
      this.details.forEach(detail => {
        detail.addEventListener("toggle", function() {
          //document.querySelector('body').classList.toggle('overflow-hidden-desktop');
        });
      });
    }

    connectedCallback() {
      // this.header = document.querySelector('.section-header');
      // this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      // this.headerBounds = {};
      // this.currentScrollTop = 0;
      // this.preventReveal = false;

      // this.onScrollHandler = this.onScroll.bind(this);
      // window.addEventListener('scroll', this.onScrollHandler, false);
    }
    // onScroll() {
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   if(scrollTop < this.currentScrollTop) {
    //     this.header.classList.remove('scrolled-past-header');
    //   } else if(scrollTop > 40) {
    //     this.header.classList.add('scrolled-past-header');
    //   }

    //   this.currentScrollTop = scrollTop;
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
